class HeaderPrimary {
  body;
  trigger;
  target;
  banner;
  targetBtnHeader;
  triggerLogo;
  logoVisible: boolean = false;
  isHomePage;

  constructor() {
    this.body = document.querySelector("body");
    this.trigger = document.querySelectorAll('[data-trigger="header-primary"]');
    this.target = document.querySelector('[data-target="header-primary"]');
    this.targetBtnHeader = document.querySelector('[data-trigger="header-btn"]');
    this.banner = document.querySelector( '[data-trigger="header-primary-banner"]');      
    this.triggerLogo = document.querySelector('[data-trigger="logo-hearder"]');

    this.isHomePage = document.querySelector(".page-template-tpl-homepage");
    if (this.isHomePage) {
      window.addEventListener('scroll', this.handleScroll.bind(this));
    }
    if (this.target) {
      this._init();
    }
  }

  _init() {
    for (let index = 0; index < this.trigger.length; index++) {
      const element = this.trigger[index];
      element.addEventListener("click", (event) => {
        this._toggleNav(event);        
      });
    }

    // close menu if you click on body
    this.body?.addEventListener("click", (event) => {
      if (this.body?.getAttribute("data-state") == "locked-for-header-primary")
        this.closeMenu();
    });
    this.targetBtnHeader?.addEventListener("click", (event) => {
      if (this.body?.getAttribute("data-state") == "locked-for-header-primary")
      this.closeMenu();
    });
    // No close menu if you click on it
    this.target?.addEventListener("click", (event) => {
      event.stopPropagation();
    });
    this.banner?.addEventListener("click", (event) => {
      event.stopPropagation();
    });



    window.addEventListener(
      "resize",
      (event) => {
        if (
          window.innerWidth >= 1025 &&
          this.body?.getAttribute("data-state") == "locked-for-header-primary"
        ) {
          this.closeMenu();
        }
      },
      true
    );
  }



  _toggleNav(event: any) {
    this._toggleState(this.body, "locked-for-header-primary", "unlocked");
    this._toggleState(this.target, "open", "closed");
    this._toggleState(event.currentTarget, "open", "closed");
    this._toggleState(this.banner, "open", "closed");
  }

  _toggleState(elem: Element | null, one: string, two: string) {
    if (elem) {
      const newState = elem.getAttribute("data-state") === one ? two : one;
      elem.setAttribute("data-state", newState);
    }
  }

  closeMenu() {
    this._toggleState(this.body, "locked-for-header-primary", "unlocked");
    this._toggleState(this.target, "open", "closed");
    this._toggleState(this.banner, "open", "closed");
  }

  handleScroll() {
    if (window.scrollY >= 70 && !this.logoVisible) {
        this.showLogo();
    }
    if (window.scrollY === 0 && this.logoVisible) {
        this.hideLogo()
    }
  }

  showLogo() {
    this.logoVisible = true;
    this.triggerLogo.setAttribute("style","opacity:1; -moz-opacity:1; filter:alpha(opacity=100)");
  }
  hideLogo() {
    this.logoVisible = false;
    this.triggerLogo.setAttribute("style","opacity:0; -moz-opacity:0; filter:alpha(opacity=0)");
  }

}

export let headerPrimary = new HeaderPrimary();
